export enum ZkPrivilege {
  PERSONNEL = 'PERSONNEL',
  ADMIN = 'ADMIN'
}
